import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "@pages/Home";

import { useScrollTriggerRefresh } from "@/lib/scroll";
import { useSmoothScroll } from "@/lib/smooth";
import CookieConsent from "@/components/CookieConsent";

const Portfolio = lazy(() => import("@/pages/Portfolio"));
const PortfolioItem = lazy(() => import("@/pages/PortfolioItem"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const ComingSoon = lazy(() => import("@/pages/ComingSoon"));

function App() {
  useSmoothScroll();
  useScrollTriggerRefresh();

  return (
    <div className="background h-screen text-ink">
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/comming-soon" element={<ComingSoon />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<PortfolioItem />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <CookieConsent />
    </div>
  );
}

export default App;
